<svg width="100%" height="100%" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4.77023 0.543457H0.957041C0.428423 0.543457 0 0.97188 0 1.5005V5.31369C0 5.84231 0.428423 6.27073 0.957041 6.27073H4.77023C5.29885 6.27073 5.72727 5.84231 5.72727 5.31369V1.5005C5.72727 0.97188 5.29885 0.543457 4.77023 0.543457Z"
    fill="black"
  />
  <path
    d="M12.4066 0.543457H8.5934C8.06479 0.543457 7.63636 0.97188 7.63636 1.5005V5.31369C7.63636 5.84231 8.06479 6.27073 8.5934 6.27073H12.4066C12.9352 6.27073 13.3636 5.84231 13.3636 5.31369V1.5005C13.3636 0.97188 12.9352 0.543457 12.4066 0.543457Z"
    fill="black"
  />
  <path
    d="M20.043 0.543457H16.2298C15.7011 0.543457 15.2727 0.97188 15.2727 1.5005V5.31369C15.2727 5.84231 15.7011 6.27073 16.2298 6.27073H20.043C20.5716 6.27073 21 5.84231 21 5.31369V1.5005C21 0.97188 20.5716 0.543457 20.043 0.543457Z"
    fill="black"
  />
  <path
    d="M4.77023 8.17982H0.957041C0.428423 8.17982 0 8.60824 0 9.13686V12.9501C0 13.4787 0.428423 13.9071 0.957041 13.9071H4.77023C5.29885 13.9071 5.72727 13.4787 5.72727 12.9501V9.13686C5.72727 8.60824 5.29885 8.17982 4.77023 8.17982Z"
    fill="black"
  />
  <path
    d="M12.4066 8.17982H8.5934C8.06479 8.17982 7.63636 8.60824 7.63636 9.13686V12.9501C7.63636 13.4787 8.06479 13.9071 8.5934 13.9071H12.4066C12.9352 13.9071 13.3636 13.4787 13.3636 12.9501V9.13686C13.3636 8.60824 12.9352 8.17982 12.4066 8.17982Z"
    fill="black"
  />
  <path
    d="M20.043 8.17982H16.2298C15.7011 8.17982 15.2727 8.60824 15.2727 9.13686V12.9501C15.2727 13.4787 15.7011 13.9071 16.2298 13.9071H20.043C20.5716 13.9071 21 13.4787 21 12.9501V9.13686C21 8.60824 20.5716 8.17982 20.043 8.17982Z"
    fill="black"
  />
  <path
    d="M4.77023 15.8162H0.957041C0.428423 15.8162 0 16.2446 0 16.7732V20.5864C0 21.115 0.428423 21.5435 0.957041 21.5435H4.77023C5.29885 21.5435 5.72727 21.115 5.72727 20.5864V16.7732C5.72727 16.2446 5.29885 15.8162 4.77023 15.8162Z"
    fill="black"
  />
  <path
    d="M12.4066 15.8162H8.5934C8.06479 15.8162 7.63636 16.2446 7.63636 16.7732V20.5864C7.63636 21.115 8.06479 21.5435 8.5934 21.5435H12.4066C12.9352 21.5435 13.3636 21.115 13.3636 20.5864V16.7732C13.3636 16.2446 12.9352 15.8162 12.4066 15.8162Z"
    fill="black"
  />
  <path
    d="M20.043 15.8162H16.2298C15.7011 15.8162 15.2727 16.2446 15.2727 16.7732V20.5864C15.2727 21.115 15.7011 21.5435 16.2298 21.5435H20.043C20.5716 21.5435 21 21.115 21 20.5864V16.7732C21 16.2446 20.5716 15.8162 20.043 15.8162Z"
    fill="black"
  />
</svg>
